module.exports = __webpack_public_path__ + "jab/media/recovery.2bc335b5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/styles/images/sp/recovery.svg
// module id = 89
// module chunks = 0